/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { HelpModalComponentArgs } from 'cio/components/help-modal';

export default class SuggestionForm extends Component<HelpModalComponentArgs> {
  @tracked suggestion = '';

  @action
  onSubmitAction(e: Event) {
    e.preventDefault();

    this.args.onSubmit({
      criticism: 'What would make forms more useful?',
      praise: this.suggestion,
    });
  }
}
